/**
 * WorkoutRoutineForm - Main Entry Point
 *
 * This file serves as the entry point for the WorkoutRoutineForm feature.
 * It imports and re-exports the refactored component from the WorkoutRoutineForm folder.
 *
 * Migration Notes:
 * - The original implementation used Formik + useState with WorkoutRoutineContext
 * - The new implementation uses React Hook Form + Zod for better performance
 * - Legacy code has been removed as part of Requirements 7.3
 *
 * Requirements: 7.1, 7.2, 7.3, 7.4 - Migration complete
 */

import * as React from 'react';

// Import the refactored component
import {WorkoutRoutineForm as RefactoredWorkoutRoutineForm} from './WorkoutRoutineForm/WorkoutRoutineForm';

import type {WorkoutRoutineStateProps} from '../../types/WorkoutRoutineConfig.type';
import type {DayWeekProps} from '../../types/Date.type';
import type {UserProps} from '../../types/User.type';
import type {WorkoutProgramProps} from '../../types/WorkoutProgram.type';
import {TabTypes} from '../../types';

/**
 * Props for the WorkoutRoutineForm component
 */
interface WorkoutRoutineFormProps {
  daysWeek: DayWeekProps[];
  users: UserProps[];
  path: 'new' | 'edit';
  programs: WorkoutProgramProps[];
  tabActive?: TabTypes;
  workoutRoutine?: WorkoutRoutineStateProps;
}

/**
 * WorkoutRoutineForm Component
 * Main entry point that uses the React Hook Form + Zod implementation
 */
function WorkoutRoutineForm(props: WorkoutRoutineFormProps): React.ReactNode {
  return (
    <RefactoredWorkoutRoutineForm
      daysWeek={props.daysWeek}
      users={props.users}
      path={props.path}
      programs={props.programs}
      tabActive={props.tabActive}
      workoutRoutine={props.workoutRoutine as any}
    />
  );
}

export default WorkoutRoutineForm;

// Re-export the refactored component for direct imports
export {RefactoredWorkoutRoutineForm as NewWorkoutRoutineForm};
